import gql from 'graphql-tag';

const LIST_CAMPAIGNORDERS_CONNECTION = gql`
  query campaignOrdersConnection(
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderOrderByInput
    $where: CampaignOrderWhereInput!
    $currentUsersOrg: ID!
  ) {
    campaignOrdersConnection(first: $first, skip: $skip, orderBy: $orderBy, where: $where) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          status
          type
          pricingModel 
          signUpCampaign
          startDate
          endDate
          attributionWindow
          budget
          cpm
          advertiser {
            id
            CPAcronym
            level
            name
            cpm
            pricingModel {
              id
              model
              hasContract
            }
            parentOrg {
              id
              level
              name
              CPAcronym
              createdAt
            }
          }
          IONumber
          productCode
          aggregateData {
            id
            overallData {
              id
              aggEvents
              aggCost
              aggTotalCost
              aggImpressions
              aggClicks
              aggVWI
              totalObservations
              signupsOverallData
            }
            dayPacingData {
              id
              aggEvents
              aggCost
              aggTotalCost
              aggImpressions
              aggClicks
              aggVWI
              totalObservations
            }
            byDate
            topCreatives
            topPublishers
          }
          pacingData {
            id
            daysLeft
            daysIntoFlight
            ctr
            roas
            dailyAvgImpressions
            dailyAvgImpressionsLeft
            impressionsLeft
            impressionGoal
            impressionsToday
            totalImpressions
            impressionsYesterday
            totalImpressionsYesterday
            impressionsLeftYesterday
            dailyAvgImpressionsYesterday
            dailyAvgImpressionsLeftYesterday
            expectedImpressions
            dailyAvgBudget
            dailyAvgBudgetLeft
            budgetLeft
            totalBudget
            budgetSpentToday
            budgetSpent
            budgetYesterday
            budgetSpentYesterday
            budgetLeftYesterday
            dailyAvgBudgetYesterday
            dailyAvgBudgetLeftYesterday
            expectedBudget
            totalBudgetSpent
            pace
            paceYesterday
            overallImpressions
            overallDeliveredImressions
            overallBudget
            overallSpend
            pacing
          }
          createdAt
          updatedAt
          externalCRMIntegrations(first: 50) {
            id
            totalPrice
          }
          campaigns(first: 25) {
            id
            cpm
            contractCPM
            advertiserPercentage
            contractPercentage
            budgetTotal
            data
            aggregateData {
              overallData {
                aggImpressions
              }
            }
          }
          attributionTargets {
            id
          }
          transactionTarget
          transactionsConfig {
            id
            appId
            cart
            traffId
            gtmAccess
            gtmStatus
            tracksBasketItems
          }
          sessionConfig {
            id
            isSession
            appId
            locationId
            cart
          }
          isRequestChange
          orgs(first: 25, where: { parentOrg_some: { id: $currentUsersOrg } }) {
            id
            name
            rpm
            level
          }
          renewalStatus
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrdersConnection(first: 5000, where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default LIST_CAMPAIGNORDERS_CONNECTION;
